export enum IUsersTypes {
  GET_USERS_REQUEST = '@users/GET_USERS_REQUEST',
  GET_USERS_SUCCESS = '@users/GET_USERS_SUCCESS',
  GET_USERS_FAILURE = '@users/GET_USERS_FAILURE',

  GET_USER_BY_APPLICATION_ID_AND_EMAIL_REQUEST = '@users/GET_USER_BY_APPLICATION_ID_AND_EMAIL_REQUEST',
  GET_USER_BY_APPLICATION_ID_AND_EMAIL_SUCCESS = '@users/GET_USER_BY_APPLICATION_ID_AND_EMAIL_SUCCESS',
  GET_USER_BY_APPLICATION_ID_AND_EMAIL_FAILURE = '@users/GET_USER_BY_APPLICATION_ID_AND_EMAIL_FAILURE',

  ADD_USER_REQUEST = '@users/ADD_USER_REQUEST',
  ADD_USER_SUCCESS = '@users/ADD_USER_SUCCESS',
  ADD_USER_FAILURE = '@users/ADD_USER_FAILURE',

  CHANGE_USER_PASSWORD_REQUEST = '@users/CHANGE_USER_PASSWORD_REQUEST',
  CHANGE_USER_PASSWORD_SUCCESS = '@users/CHANGE_USER_PASSWORD_SUCCESS',
  CHANGE_USER_PASSWORD_FAILURE = '@users/CHANGE_USER_PASSWORD_FAILURE',
  CHANGE_USER_PASSWORD_RESET_REQUEST = '@users/CHANGE_USER_PASSWORD_RESET_REQUEST',

  ACTIVATE_USER_REQUEST = '@users/ACTIVATE_USER_REQUEST',
  ACTIVATE_USER_SUCCESS = '@users/ACTIVATE_USER_SUCCESS',
  ACTIVATE_USER_FAILURE = '@users/ACTIVATE_USER_FAILURE',

  GET_GROUPS_REQUEST = '@users/GET_GROUPS_REQUEST',
  GET_GROUPS_SUCCESS = '@users/GET_GROUPS_SUCCESS',
  GET_GROUPS_FAILURE = '@users/GET_GROUPS_FAILURE',

  GET_USER_GROUPS_REQUEST = '@users/GET_USER_GROUPS_REQUEST',
  GET_USER_GROUPS_SUCCESS = '@users/GET_USER_GROUPS_SUCCESS',
  GET_USER_GROUPS_FAILURE = '@users/GET_USER_GROUPS_FAILURE',

  ADD_USER_GROUP_REQUEST = '@users/ADD_USER_GROUP_REQUEST',
  ADD_USER_GROUP_SUCCESS = '@users/ADD_USER_GROUP_SUCCESS',
  ADD_USER_GROUP_FAILURE = '@users/ADD_USER_GROUP_FAILURE',

  REMOVE_USER_GROUP_REQUEST = '@users/REMOVE_USER_GROUP_REQUEST',
  REMOVE_USER_GROUP_SUCCESS = '@users/REMOVE_USER_GROUP_SUCCESS',
  REMOVE_USER_GROUP_FAILURE = '@users/REMOVE_USER_GROUP_FAILURE',

  GET_USER_PROFILE_REQUEST = '@users/GET_USER_PROFILE_REQUEST',
  GET_USER_PROFILE_SUCCESS = '@users/GET_USER_PROFILE_SUCCESS',
  GET_USER_PROFILE_FAILURE = '@users/GET_USER_PROFILE_FAILURE',

  GET_PROFILES_REQUEST = '@users/GET_PROFILES_REQUEST',
  GET_PROFILES_SUCCESS = '@users/GET_PROFILES_SUCCESS',
  GET_PROFILES_FAILURE = '@users/GET_PROFILES_FAILURE',

  GET_USER_PROFILES_REQUEST = '@users/GET_USER_PROFILES_REQUEST',
  GET_USER_PROFILES_SUCCESS = '@users/GET_USER_PROFILES_SUCCESS',
  GET_USER_PROFILES_FAILURE = '@users/GET_USER_PROFILES_FAILURE',

  ADD_USER_PROFILE_REQUEST = '@users/ADD_USER_PROFILE_REQUEST',
  ADD_USER_PROFILE_SUCCESS = '@users/ADD_USER_PROFILE_SUCCESS',
  ADD_USER_PROFILE_FAILURE = '@users/ADD_USER_PROFILE_FAILURE',

  UPDATE_USER_PROFILE_REQUEST = '@users/UPDATE_USER_PROFILE_REQUEST',
  UPDATE_USER_PROFILE_SUCCESS = '@users/UPDATE_USER_PROFILE_SUCCESS',
  UPDATE_USER_PROFILE_FAILURE = '@users/UPDATE_USER_PROFILE_FAILURE',

  REMOVE_USER_PROFILE_REQUEST = '@users/REMOVE_USER_PROFILE_REQUEST',
  REMOVE_USER_PROFILE_SUCCESS = '@users/REMOVE_USER_PROFILE_SUCCESS',
  REMOVE_USER_PROFILE_FAILURE = '@users/REMOVE_USER_PROFILE_FAILURE',

  GET_CAMUNDA_USERS_REQUEST = '@users/GET_CAMUNDA_USERS_REQUEST',
  GET_CAMUNDA_USERS_SUCCESS = '@users/GET_CAMUNDA_USERS_SUCCESS',
  GET_CAMUNDA_USERS_FAILURE = '@users/GET_CAMUNDA_USERS_FAILURE',

  GET_ACTIVATED_USERS_REQUEST = '@users/GET_ACTIVATED_USERS_REQUEST',
  GET_ACTIVATED_USERS_SUCCESS = '@users/GET_ACTIVATED_USERS_SUCCESS',
  GET_ACTIVATED_USERS_FAILURE = '@users/GET_ACTIVATED_USERS_FAILURE',

  GET_USERS_BY_GROUPS_REQUEST = '@users/GET_USERS_BY_GROUPS_REQUEST',
  GET_USERS_BY_GROUPS_SUCCESS = '@users/GET_USERS_BY_GROUPS_SUCCESS',
  GET_USERS_BY_GROUPS_FAILURE = '@users/GET_USERS_BY_GROUPS_FAILURE',
}

export interface IGetUsersRequestAction {
  type: typeof IUsersTypes.GET_USERS_REQUEST;
  payload: {
    page: number;
    limit: number;
    search: string;
  };
}
export interface IGetUsersSuccessAction {
  type: typeof IUsersTypes.GET_USERS_SUCCESS;
  payload: {
    users: IUser[];
    pagecount: number;
    total: number;
  };
}
export interface IGetUsersFailureAction {
  type: typeof IUsersTypes.GET_USERS_FAILURE;
}

export interface IGetUserByApplicationIdAndEmailRequestAction {
  type: typeof IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_REQUEST;
  payload: {
    applicationId: number;
    email: string;
  };
}
export interface IGetUserByApplicationIdAndEmailSuccessAction {
  type: typeof IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_SUCCESS;
  payload: {
    user: IUser;
  };
}
export interface IGetUserByApplicationIdAndEmailFailureAction {
  type: typeof IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_FAILURE;
}

export interface IAddUserRequestAction {
  type: typeof IUsersTypes.ADD_USER_REQUEST;
  payload: {
    data: {
      [key: string]: unknown;
    };
  };
}
export interface IAddUserSuccessAction {
  type: typeof IUsersTypes.ADD_USER_SUCCESS;
}
export interface IAddUserFailureAction {
  type: typeof IUsersTypes.ADD_USER_FAILURE;
}

export interface IChangeUserPasswordRequestAction {
  type: typeof IUsersTypes.CHANGE_USER_PASSWORD_REQUEST;
  payload: {
    id: number;
    managerId?: number;
    password?: string;
    newPassword?: string;
    personId?: number | undefined;
    userEmail?: string;
  };
}
export interface IChangeUserPasswordSuccessAction {
  type: typeof IUsersTypes.CHANGE_USER_PASSWORD_SUCCESS;
}
export interface IChangeUserPasswordFailureAction {
  type: typeof IUsersTypes.CHANGE_USER_PASSWORD_FAILURE;
}

export interface IChangeUserPasswordResetRequestAction {
  type: typeof IUsersTypes.CHANGE_USER_PASSWORD_RESET_REQUEST;
}

export interface IActivateUserRequestAction {
  type: typeof IUsersTypes.ACTIVATE_USER_REQUEST;
  payload: {
    user_id: number;
    activate: boolean;
  };
}
export interface IActivateUserSuccessAction {
  type: typeof IUsersTypes.ACTIVATE_USER_SUCCESS;
  payload: {
    user_id: number;
    activate: boolean;
  };
}
export interface IActivateUserFailureAction {
  type: typeof IUsersTypes.ACTIVATE_USER_FAILURE;
}

export interface IGetGroupsRequestAction {
  type: typeof IUsersTypes.GET_GROUPS_REQUEST;
}
export interface IGetGroupsSuccessAction {
  type: typeof IUsersTypes.GET_GROUPS_SUCCESS;
  payload: {
    groups: IGroup[];
  };
}
export interface IGetGroupsFailureAction {
  type: typeof IUsersTypes.GET_GROUPS_FAILURE;
}

export interface IGetUserGroupsRequestAction {
  type: typeof IUsersTypes.GET_USER_GROUPS_REQUEST;
  payload: {
    user_id: number;
  };
}
export interface IGetUserGroupsSuccessAction {
  type: typeof IUsersTypes.GET_USER_GROUPS_SUCCESS;
  payload: {
    user_id: number;
    groups: IGroup[];
  };
}
export interface IGetUserGroupsFailureAction {
  type: typeof IUsersTypes.GET_USER_GROUPS_FAILURE;
}

export interface IAddUserGroupRequestAction {
  type: typeof IUsersTypes.ADD_USER_GROUP_REQUEST;
  payload: {
    user_id: number;
    group: IGroup;
  };
}
export interface IAddUserGroupSuccessAction {
  type: typeof IUsersTypes.ADD_USER_GROUP_SUCCESS;
  payload: {
    user_id: number;
    group: IGroup;
  };
}
export interface IAddUserGroupFailureAction {
  type: typeof IUsersTypes.ADD_USER_GROUP_FAILURE;
}

export interface IRemoveUserGroupRequestAction {
  type: typeof IUsersTypes.REMOVE_USER_GROUP_REQUEST;
  payload: {
    user_id: number;
    group: IGroup;
  };
}
export interface IRemoveUserGroupSuccessAction {
  type: typeof IUsersTypes.REMOVE_USER_GROUP_SUCCESS;
  payload: {
    user_id: number;
    group: IGroup;
  };
}
export interface IRemoveUserGroupFailureAction {
  type: typeof IUsersTypes.REMOVE_USER_GROUP_FAILURE;
}

export interface IGetUserProfileRequestAction {
  type: typeof IUsersTypes.GET_USER_PROFILE_REQUEST;
  payload: {
    personId: number;
  };
}
export interface IGetUserProfileSuccessAction {
  type: typeof IUsersTypes.GET_USER_PROFILE_SUCCESS;
  payload: {
    userProfile: IUserProfile;
  };
}
export interface IGetUserProfileFailureAction {
  type: typeof IUsersTypes.GET_USER_PROFILE_FAILURE;
}

export interface IGetProfilesRequestAction {
  type: typeof IUsersTypes.GET_PROFILES_REQUEST;
}
export interface IGetProfilesSuccessAction {
  type: typeof IUsersTypes.GET_PROFILES_SUCCESS;
  payload: {
    profiles: IProfile[];
  };
}
export interface IGetProfilesFailureAction {
  type: typeof IUsersTypes.GET_PROFILES_FAILURE;
}

export interface IGetUserProfilesRequestAction {
  type: typeof IUsersTypes.GET_USER_PROFILES_REQUEST;
  payload: {
    user_id: number;
  };
}
export interface IGetUserProfilesSuccessAction {
  type: typeof IUsersTypes.GET_USER_PROFILES_SUCCESS;
  payload: {
    user_id: number;
    profiles: IProfile[];
  };
}
export interface IGetUserProfilesFailureAction {
  type: typeof IUsersTypes.GET_USER_PROFILES_FAILURE;
}

export interface IAddUserProfileRequestAction {
  type: typeof IUsersTypes.ADD_USER_PROFILE_REQUEST;
  payload: {
    user_id: number;
    profile: IProfile;
  };
}
export interface IAddUserProfileSuccessAction {
  type: typeof IUsersTypes.ADD_USER_PROFILE_SUCCESS;
  payload: {
    user_id: number;
    profile: IProfile;
  };
}
export interface IAddUserProfileFailureAction {
  type: typeof IUsersTypes.ADD_USER_PROFILE_FAILURE;
}

export interface IUpdateUserProfileRequestAction {
  type: typeof IUsersTypes.UPDATE_USER_PROFILE_REQUEST;
  payload: {
    personId: number;
    userProfile: IUserProfile;
  };
}
export interface IUpdateUserProfileSuccessAction {
  type: typeof IUsersTypes.UPDATE_USER_PROFILE_SUCCESS;
  payload: {
    userProfile: IUserProfile;
  };
}
export interface IUpdateUserProfileFailureAction {
  type: typeof IUsersTypes.UPDATE_USER_PROFILE_FAILURE;
}

export interface IRemoveUserProfileRequestAction {
  type: typeof IUsersTypes.REMOVE_USER_PROFILE_REQUEST;
  payload: {
    user_id: number;
    profile: IProfile;
  };
}
export interface IRemoveUserProfileSuccessAction {
  type: typeof IUsersTypes.REMOVE_USER_PROFILE_SUCCESS;
  payload: {
    user_id: number;
    profile: IProfile;
  };
}
export interface IRemoveUserProfileFailureAction {
  type: typeof IUsersTypes.REMOVE_USER_PROFILE_FAILURE;
}

export interface IGetCamundaUsersRequestAction {
  type: typeof IUsersTypes.GET_CAMUNDA_USERS_REQUEST;
}
export interface IGetCamundaUsersSuccessAction {
  type: typeof IUsersTypes.GET_CAMUNDA_USERS_SUCCESS;
  payload: {
    camundaUsers: ICamundaUser[];
  };
}
export interface IGetCamundaUsersFailureAction {
  type: typeof IUsersTypes.GET_CAMUNDA_USERS_FAILURE;
}

export interface IGetActivatedUsersRequestAction {
  type: typeof IUsersTypes.GET_ACTIVATED_USERS_REQUEST;
  payload: {
    profileKey?: string;
  };
}
export interface IGetActivatedUsersSuccessAction {
  type: typeof IUsersTypes.GET_ACTIVATED_USERS_SUCCESS;
  payload: {
    activatedUsers: IActivatedUsers[];
  };
}
export interface IGetActivatedUsersFailureAction {
  type: typeof IUsersTypes.GET_ACTIVATED_USERS_FAILURE;
}

export interface IGetUsersByGroupsRequestAction {
  type: typeof IUsersTypes.GET_USERS_BY_GROUPS_REQUEST;
  payload: {
    groups: IGroup[];
  };
}
export interface IGetUsersByGroupsSuccessAction {
  type: typeof IUsersTypes.GET_USERS_BY_GROUPS_SUCCESS;
  payload: {
    user_id: number;
    groups: IGroup[];
    usersByGroups: IUser[];
  };
}
export interface IGetUsersByGroupsFailureAction {
  type: typeof IUsersTypes.GET_USERS_BY_GROUPS_FAILURE;
}

export enum ChangePasswordStatus {
  REQUEST = 'request',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export type IUsersActionsType =
  | IGetUsersRequestAction
  | IGetUsersSuccessAction
  | IGetUsersFailureAction
  | IGetUserByApplicationIdAndEmailRequestAction
  | IGetUserByApplicationIdAndEmailSuccessAction
  | IGetUserByApplicationIdAndEmailFailureAction
  | IAddUserRequestAction
  | IAddUserSuccessAction
  | IAddUserFailureAction
  | IChangeUserPasswordRequestAction
  | IChangeUserPasswordSuccessAction
  | IChangeUserPasswordFailureAction
  | IChangeUserPasswordResetRequestAction
  | IActivateUserRequestAction
  | IActivateUserSuccessAction
  | IActivateUserFailureAction
  | IGetGroupsRequestAction
  | IGetGroupsSuccessAction
  | IGetGroupsFailureAction
  | IGetUserGroupsRequestAction
  | IGetUserGroupsSuccessAction
  | IGetUserGroupsFailureAction
  | IAddUserGroupRequestAction
  | IAddUserGroupSuccessAction
  | IAddUserGroupFailureAction
  | IRemoveUserGroupRequestAction
  | IRemoveUserGroupSuccessAction
  | IRemoveUserGroupFailureAction
  | IGetUserProfileRequestAction
  | IGetUserProfileSuccessAction
  | IGetUserProfileFailureAction
  | IGetProfilesRequestAction
  | IGetProfilesSuccessAction
  | IGetProfilesFailureAction
  | IGetUserProfilesRequestAction
  | IGetUserProfilesSuccessAction
  | IGetUserProfilesFailureAction
  | IAddUserProfileRequestAction
  | IAddUserProfileSuccessAction
  | IAddUserProfileFailureAction
  | IUpdateUserProfileRequestAction
  | IUpdateUserProfileSuccessAction
  | IUpdateUserProfileFailureAction
  | IRemoveUserProfileRequestAction
  | IRemoveUserProfileSuccessAction
  | IRemoveUserProfileFailureAction
  | IGetCamundaUsersRequestAction
  | IGetCamundaUsersSuccessAction
  | IGetCamundaUsersFailureAction
  | IGetActivatedUsersRequestAction
  | IGetActivatedUsersSuccessAction
  | IGetActivatedUsersFailureAction
  | IGetUsersByGroupsRequestAction
  | IGetUsersByGroupsSuccessAction
  | IGetUsersByGroupsFailureAction;

export interface IGroup {
  id: string;
  name?: string;
  type?: string;
}

export interface IProfile {
  id: number;
  name: string;
  permissions: string[];
  profileKey: string;
}

// TODO(MIKE) RENOMEAR SECURITY/PERSON
export interface IUserProfile {
  aboutMe?: string;
  activated?: boolean;
  admissionDate?: Date;
  applicationId?: number;
  cpf: string;
  creationDate?: number;
  departmentName?: string;
  displayName?: string;
  dynamicAttributes: {
    area: string;
    city: string;
    state: string;
    groups?: IGroup;
    number: string;
    office: string;
    phone1: string;
    phone2: string;
    street: string;
    manager: string;
    subArea: string;
    zipCode: string;
    district: string;
    complement: string;
    specialNeed?: string;
    emailContact: string;
  };
  email: string;
  firstName: string;
  followers?: number;
  following?: number;
  gender?: string;
  hidePrivateData?: boolean;
  id?: number;
  lastName: string;
  locale?: string;
  managerEmail?: string;
  managerId?: string;
  managerName?: string;
  orgId?: number;
  position?: string;
  registration: string;
  termsAccepted?: boolean;
  thumbnail?: string;
  username?: string;
}

export interface IUserDynamicAttributes {
  ticket: string;
  PASSWORD_ATTRIBUTE: string;
  roles: string;
  [key: string]: any;
}

export interface IOrganization {
  orgKey: string;
}

export interface IUser {
  id: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  cpf?: string;
  organizations?: number;
  departamentName?: string;
  division?: string;
  activated?: boolean;
  userName?: string;
  orgId: string;
  departmentName: string;
  position: string;
  managerName: string;
  registration: string;
  admin: boolean;
  applicationId: number;
  lastLogin: number;
  moduleIds: [];
  mustChangePassword: boolean;
  permissions: unknown[];
  personId: number;
  profiles: IProfile[];
  sessionTimeout: number;
  username: string;
  orgKey: string;
  orgName: string;
  groups: IGroup[];
  dynamicAttributes: IUserDynamicAttributes;
  message?: string;
  thumbnail: string;
}

export interface IUserState {
  loading: boolean;
  loadingActivation: boolean;
  loadingGroupsOrProfile: boolean;
  loadingUsersByGroups: boolean;
  loadingActiveUsers: boolean;
  users: IUser[];
  user: IUser | undefined;
  pagecount: number;
  total: number;
  groups: IGroup[];
  userProfile: IUserProfile | undefined;
  changePasswordError: boolean | undefined;
  profiles: IProfile[];
  camundaUsers: ICamundaUser[];
  activatedUsers: IActivatedUsers[];
  usersByGroups: IUser[];
  changePasswordStatus: ChangePasswordStatus;
}

export interface ICamundaUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  candidateGroups: Array<IGroup>;
}

export interface IActivatedUsers {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}
